/**
 * Telas do fluxo de agendamento.
 *
 * Os valores sao os mesmos numeros usados antes, para nao alterar o
 * comportamento — a mudanca e apenas dar nome a eles.
 */
export const VIEW = {
  LOADING: 0, // estado inicial, antes de a config carregar
  SAVED: 1, // Meus Agendamentos (destino do fluxo)
  ROOMS: 2, // Agenda: lista de salas
  ROOM_TIMES: 3, // Horarios da sala selecionada
};

/**
 * Falhas que substituem o conteudo da pagina.
 *
 * Antes eram as telas 4, 5 e 6 do mesmo `step`. Separadas em um estado
 * proprio, porque nao sao etapas do fluxo e nunca convivem com ele.
 */
export const ERROR = {
  CONFIG_NOT_FOUND: "CONFIG_NOT_FOUND",
  LOGIN_NOT_FOUND: "LOGIN_NOT_FOUND",
  PARAMS_NOT_FOUND: "PARAMS_NOT_FOUND",
};
